let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kuuFH")).then(() => parcelRequire('gwan4'));